/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_All_LabelInputs */

const en_error_nav_all_label = /** @type {(inputs: Error_Nav_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`all`)
};

const fr_error_nav_all_label = /** @type {(inputs: Error_Nav_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`toutes`)
};

const de_error_nav_all_label = /** @type {(inputs: Error_Nav_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`alle`)
};

const it_error_nav_all_label = /** @type {(inputs: Error_Nav_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutto`)
};

const ru_error_nav_all_label = /** @type {(inputs: Error_Nav_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`все`)
};

const es_error_nav_all_label = /** @type {(inputs: Error_Nav_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`todo`)
};

const zh_cn2_error_nav_all_label = /** @type {(inputs: Error_Nav_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部`)
};

const ja_error_nav_all_label = /** @type {(inputs: Error_Nav_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全て`)
};

const hi_error_nav_all_label = /** @type {(inputs: Error_Nav_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी`)
};

const pt_pt2_error_nav_all_label = /** @type {(inputs: Error_Nav_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`todos`)
};

/**
* | output |
* | --- |
* | "all" |
*
* @param {Error_Nav_All_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_all_label = /** @type {((inputs?: Error_Nav_All_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_All_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_error_nav_all_label(inputs)
	if (locale === "de") return de_error_nav_all_label(inputs)
	if (locale === "it") return it_error_nav_all_label(inputs)
	if (locale === "ru") return ru_error_nav_all_label(inputs)
	if (locale === "es") return es_error_nav_all_label(inputs)
	if (locale === "zh-CN") return zh_cn2_error_nav_all_label(inputs)
	if (locale === "ja") return ja_error_nav_all_label(inputs)
	if (locale === "hi") return hi_error_nav_all_label(inputs)
	if (locale === "pt-PT") return pt_pt2_error_nav_all_label(inputs)
	return en_error_nav_all_label(inputs)
});